import React from "react";
import { ZapIcon, GlobeIcon, ShieldCheckIcon, ChefHatIcon } from "lucide-react";
import { CtaButton } from "./CtaButton";
import { Stars } from "./Stars";
import { productImage } from "../data/salesContent";
import { useCountdown } from "../hooks/useCountdown";
export function Hero() {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown(23);
  return <header className="w-full bg-white" data-id="element-75" data-mp="4jm71qy2f7s5">
      <div className="bg-ink px-4 py-2.5 text-center text-sm text-cream" data-id="element-76" data-mp="129qurmgy5roe">
        <span className="font-semibold text-gold" data-id="element-77" data-mp="xae6qyecaek8">Precio de lanzamiento $17</span>
        <span className="mx-2 text-cream/40" data-id="element-78" data-mp="x8bcg265lz9p">·</span>
        sube en{" "}
        <span className="font-display font-bold tabular-nums text-gold-bright" data-id="element-79" data-mp="s9q93tvluzh1">
          {hours}:{minutes}:{seconds}
        </span>
      </div>

      <div className="mx-auto grid max-w-7xl items-center gap-10 px-5 py-12 lg:grid-cols-[1fr_1.15fr] lg:gap-8 lg:py-16" data-id="element-80" data-mp="3d1a7phvug7c8">
        <div className="text-center lg:text-left" data-id="element-81" data-mp="3825y4q50c7ld">
          <div className="mb-5 inline-flex items-center gap-2 text-ink" data-id="element-82" data-mp="384jtz17ihntz">
            <ChefHatIcon className="h-5 w-5 text-gold-deep" aria-hidden="true" data-id="element-83" data-mp="3j925rpk1dsw2" />
            <span className="font-display text-sm font-extrabold tracking-wide" data-id="element-84" data-mp="3o6ki7px9iq8t">
              MEGAPACK FRANQUICIA REPOSTERÍA™
            </span>
          </div>

          <h1 className="font-display text-4xl font-black leading-[1.05] text-ink sm:text-5xl xl:text-6xl" data-id="element-85" data-mp="3e9fqlakne2km">
            Tu negocio de tortas rentable.{" "}
            <span className="text-gold-deep" data-id="element-86" data-mp="30ggfdkrweuiv">Listo. Desde hoy.</span>
          </h1>

          <p className="mt-5 font-display text-lg font-bold text-cocoa sm:text-xl" data-id="element-87" data-mp="359j9pv4i2804">
            6 Tomos + 5 Bonos — De $0 a ganancia en 30 días
          </p>

          <p className="mx-auto mt-4 max-w-xl text-base leading-relaxed text-muted lg:mx-0" data-id="element-88" data-mp="2viomoojfj4dm">
            Recetas + Plantillas + Guiones + Fotos — listos para usar. Sin buscar. Sin improvisar.
            Sin perder dinero en pruebas fallidas.
          </p>

          <div className="mt-8 flex flex-col items-center gap-5 lg:items-start" data-id="element-89" data-mp="2lk8qw89gj6xs">
            <CtaButton data-id="element-90" data-mp="s2tf1pz30hru" />
            <ul className="flex flex-wrap justify-center gap-x-5 gap-y-2 text-sm font-medium text-ink lg:justify-start" data-id="element-91" data-mp="s3co0h6r7vtq">
              <li className="flex items-center gap-1.5" data-id="element-92" data-mp="ic85x8ls7uuo">
                <ZapIcon className="h-4 w-4 text-gold-deep" aria-hidden="true" data-id="element-93" data-mp="icrpetr2yrat" /> Acceso en 5 min
              </li>
              <li className="flex items-center gap-1.5" data-id="element-94" data-mp="deyk02xlq1bl">
                <GlobeIcon className="h-4 w-4 text-gold-deep" aria-hidden="true" data-id="element-95" data-mp="1b15qjidgu3ql" /> LATAM completo
              </li>
              <li className="flex items-center gap-1.5" data-id="element-96" data-mp="163472wc4o2el">
                <ShieldCheckIcon className="h-4 w-4 text-gold-deep" aria-hidden="true" data-id="element-97" data-mp="112g55fmd215l" /> Garantía 7 días
              </li>
            </ul>
          </div>

          <div className="mt-8 flex items-center justify-center gap-4 border-t border-cream-deep pt-6 lg:justify-start" data-id="element-98" data-mp="x0l328wlvjqr">
            <div className="flex -space-x-2" aria-hidden="true" data-id="element-99" data-mp="3lqm1dvdxqztc">
              {["MJ", "CR", "AP"].map(i => <span key={i} className="flex h-9 w-9 items-center justify-center rounded-full border-2 border-white bg-ink font-display text-[11px] font-bold text-gold" data-id="element-100" data-mp="1x9b6134gx5dm">
                  {i}
                </span>)}
            </div>
            <div className="text-left" data-id="element-101" data-mp="2b0pptc679alq">
              <div className="flex items-center gap-2" data-id="element-102" data-mp="2b1hk8jo292af">
                <Stars data-id="element-103" data-mp="2fzsqylj26wof" />
                <span className="font-display text-sm font-extrabold text-ink" data-id="element-104" data-mp="2g0lpx0bs0hw0">4.9/5</span>
              </div>
              <p className="text-sm text-muted" data-id="element-105" data-mp="2kxuebinipi5p">+1.200 emprendedores confían</p>
            </div>
          </div>
        </div>

        <div data-id="element-106" data-mp="2p1a5hzgtiqb0">
          <img src={productImage} alt="MegaPack Franquicia Repostería: 6 tomos, 5 bonos, 420+ páginas, $17 USD y garantía de 7 días" className="w-full" data-id="element-107" data-mp="2oyebunc06nsd" />
        </div>
      </div>
    </header>;
}